// extracted by mini-css-extract-plugin
export var smallSpinner = "_r4-0";